import React from "react";
import { FormattedMessage } from "react-intl";
import ContentLayout from "../ContentLayout";

function Error() {
  return (
    <ContentLayout>
      <h1 className="mt-2 text-3xl font-bold leading-none text-heading-color">
        <FormattedMessage id="giftCard.expired" />
      </h1>
    </ContentLayout>
  );
}

export default Error;
